import CalendarInput from "@/components/calendarInput/calendarInput.vue";
import ConfirmChangeDatesModal from "@/components/modal/confirmChangeDatesModal.vue";
import { createNamespacedHelpers } from "vuex";

const { mapActions: userActions } = createNamespacedHelpers("user");

export default {
	props: {
		/*
		 * if provided, that means we are in edit mode,
		 * Be careful, this is a reference,
		 * changing this object will mutate the parent
		 */
		editDate: Object,
	},

	components: {
		CalendarInput,
		ConfirmChangeDatesModal,
	},

	data() {
		return {
			date: {
				start: new Date(),
				end: new Date(),
			},
			showConfirmModal: false,
		};
	},

	created() {
		if (this.editDate) {
			this.date = {
				start: new Date(this.editDate.start_date),
				end: new Date(this.editDate.end_date),
			};
		}
	},

	methods: {
		onConfirmSave,
		edit,
		create,

		...userActions(["addExceptionalClosedDay", "editExceptionalClosedDay"]),
	},
};

async function edit() {
	try {
		await this.editExceptionalClosedDay({
			__key: this.editDate.__key,
			start_date: this.date.start,
			end_date: this.date.end,
		});

		this.$emit("save");
	} catch (error) {
		if (error.message) {
			this.$swal({
				text: error.message,
				customClass: "swal_modal",
			});
		}
	}
}

async function create() {
	try {
		await this.addExceptionalClosedDay({
			start_date: this.date.start,
			end_date: this.date.end,
		});

		this.$ma.trackEvent({
			action: "New Outstanding Event Added",
			properties: {
				Value: {
					StartDate: this.date.start,
					EndDate: this.date.end,
				},
				Component: this.$route.name,
			},
		});

		this.$emit("save");
	} catch (error) {
		if (error.message) {
			this.showConfirmModal = false;

			this.$swal({
				text: error.message,
				customClass: "swal_modal",
			});
		}
	}
}

function onConfirmSave() {
	if (this.editDate) this.edit();
	else this.create();
}
